import React, { useState, useEffect } from "react";
import Header from "../../Components/HeaderAdmin/Header";
import CustomSelectIcon from "./SelectBarview";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getremoteInquirydataApi, removeuserdatails, getemptyremotekitapi, updateRemotekit, addnewgolferapi, updatedata, sendvarification, updatenewgolfer, resetremotefitting } from "../../Api/iron";
import Modal from 'react-bootstrap/Modal';
import { IoClose } from "react-icons/io5";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { IoCloseSharp } from "react-icons/io5";
import { getCurrentUser } from "../../Api/auth";
import { addnotes, getnotes } from "../../Api/prescriptionApis"
import Loader2 from "../DashboardComponents/Loader/Loader2";
import { TfiReload } from "react-icons/tfi";
import { MdMarkEmailRead, MdOutlineModeEdit } from "react-icons/md";

function RemotekitView() {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const [isLoading, setIsLoading] = useState(true);
    const params = useParams();
    const [dataNull, setDataNull] = useState(null);
    const [apicall, setApicall] = useState(false);
    const [errors, setErrors] = useState([]);
    const [errorid, setErrorid] = useState(0);
    const [validated, setValidated] = useState(false);
    const [user_id, setUser_id] = useState(0);
    const [fitter_id, setFitter_id] = useState(null);
    const [status, setStatus] = useState("rejected");

    const jsonparserror = JSON.parse(errorid);

    const [notesdata, setnotesData] = useState([]);
    const [notes, setnotes] = useState('')
    const [showerror, setShowererror] = useState(false);
    const [user, setUser] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);

    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const [show1, setShow1] = useState(false);

    const handleClosereset = () => setShowreset(false);
    const handleShowreset = () => setShowreset(true);
    const [showreset, setShowreset] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);
    const [show2, setShow2] = useState(false);

    const handleCloseConfirmation = () => setShowConfirmation(false);
    const handleShowConfirmation = () => setShowConfirmation(true);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [editable, setEditable] = useState(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [dbemail, setDbEmail] = useState("");
    const [password, setPassword] = useState("");
    const [descripation, setDescripation] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [heightft, setHeightft] = useState('');
    const [heightin, setHeightin] = useState('');
    const [dexterity, setDexterity] = useState('');
    const [textPassword, setTextPassword] = useState('123456');

    const [address, setAddress] = useState("");
    const [zip, setZip] = useState("");


    const userData = localStorage.getItem("user");
    const userJson = JSON.parse(userData);

    const [golfers, setGolfers] = useState([]);
    const [selectedGolfer, setSelectedGolfer] = useState(0);

    const [checkemail, setCheckemail] = useState(false);
    // Function to add a new golfer
    const addGolfer = () => {
        const newGolfer = {
            id: golfers.length + 1, // Simple id assignment (you might want to use a more robust method)
            firstName: '',
            lastName: '',
            phone: '',
            email: ''
        };
        setGolfers([...golfers, newGolfer]);
    };

    // Function to remove a golfer
    const removeGolfer = () => {
        // if (window.confirm('Are you sure you want to remove this golfer?')) {
        // showConfirmation();
        setApicall(true);
        const data = {
            user_id: user_id,
            guest_id: selectedGolfer,
            project_id: params.id
        }
        removeuserdatails(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.message);
            } else {
                const data = response.data.data;
                handleCloseConfirmation();
                handleShow1();
                setGolfers(golfers.filter(golfer => golfer.id !== selectedGolfer));
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
        // }
    };


    function goBack() {
        window.history.back()
    }


    const [selectedOption2, setSelectedOption2] = useState('Assigned');
    const [selectedOption3, setSelectedOption3] = useState('Remote Kit');
    const [selectedOption3Id, setSelectedOption3Id] = useState('0');
    const [apicallupate, setApicallupdate] = useState(false);

    const getremoteInquirydata = () => {
        setApicall(true);
        setIsLoading(true);
        const data = {
            id: params.id
        }
        getremoteInquirydataApi(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.data.data);
            } else {
                const data = response.data.data;

                setFirstName(data.firstname);
                setLastName(data.lastname);
                setEmail(data.email);
                setPhone(data.phone);
                setDescripation(data.notes);
                setCity(data.shippingcity);
                setState(data.shippingstate);
                setPassword(data.password);
                setAddress(data.shippingaddress);
                setHeightin(data.height_in);
                setHeightft(data.height_ft);
                setDexterity(data.dexterity);
                setZip(data.shippingzip);
                setTextPassword(data.text_password);
                setUser(data.user_id);
                setSelectedOption2(data.remote_kit_status);
                setSelectedOption3Id(data.remote_kit_id);
                setSelectedOption3(data.remote_kit_text);
                // setlastkeyword(fit);
                setUser_id(data.user_id);
                setStatus(data.stage);

                if (data.stage === "Purchased") {
                    setEditable(true);
                }

                if (data.golfdata && Array.isArray(data.golfdata)) {
                    const formattedGolfers = data.golfdata.map((golfer, index) => ({
                        id: golfer.id,
                        firstName: golfer.firstName,
                        lastName: golfer.lastName,
                        phone_number: golfer.phone_number,
                        email: golfer.email,
                        dexterity: golfer.dexterity,
                        heightft: golfer.heightft,
                        heightin: golfer.heightin
                    }));
                    setGolfers(formattedGolfers);
                } else {
                    console.log("false");
                    setGolfers([]);
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setIsLoading(false);
        });
    };

    const handleGolferChange = (index, field, value) => {
        const updatedGolfers = golfers.map((golfer, i) => {
            if (i === index) {
                return { ...golfer, [field]: value };
            }
            return golfer;
        });
        setGolfers(updatedGolfers);
    };


    const options2 = [
        { text: 'Assigned', color: 'orange' },
        { text: 'En Route', color: 'yellow' },
        { text: 'Recieved', color: 'green' },
        { text: 'Returning', color: 'goldenorange' },
        { text: 'Landed', color: 'blue' },
        { text: 'Completed', color: 'green' }
    ];

    const [isOpen2, setIsOpen2] = useState(false);

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };


    const selectOption2 = (option) => {
        setSelectedOption2(option);
    };


    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setFitter_id(getCurrentUserdata.user._id);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    const handleaddnotes = () => {
        setApicall(true);

        if (notes === "") {
            setShowererror(true);
            setApicall(false);
            return false;
        }

        const data = {
            notes: notes,
            user_id: user_id,
            project_id: params.id,
            fitter_id: fitter_id
        }

        addnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleShow();
                handlegetnotes();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setShowererror(false);
            setApicall(false);
            setValidated(true);
            setnotes('');
        });
    };

    const handlegetnotes = () => {
        const data = {
            project_id: params.id
        }
        getnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setnotesData(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setValidated(true);
        });
    };

    const [options3, setOptions3] = useState([]);

    const getemptyremotekit = () => {
        setApicall(true);
        getemptyremotekitapi().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setOptions3(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    useEffect(() => {
        getremoteInquirydata();
        handlegetnotes()
        getemptyremotekit();
    }, [params.id])


    const getColorClass = () => {
        const selectedColor = options2.find(opt => opt.text === selectedOption2)?.color;
        return selectedColor ? `${selectedColor}` : 'white';
    };

    const updateRemotekitstatus = () => {
        // setApicall(true);
        setApicallupdate(true);
        const data = {
            id: params.id,
            remote_kit_status: selectedOption2,
        }
        updateRemotekit(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                if (selectedOption2 === "Completed") {
                    window.location.href = "/remote_kits";
                } else {
                    window.location.reload();
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            // setApicall(false);
            setApicallupdate(false);
            setValidated(false);
        });
    }


    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const [showaddModal, setShowaddModal] = useState(false);
    const handleaddClose = () => setShowaddModal(false);
    const handleaddShow = () => setShowaddModal(true);

    const golferInitialState = {
        id: golfers.length + 1,
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        height_ft: 0,
        height_in: 0,
        dexterity: 0
    };

    const [golfer, setGolfer] = useState(golferInitialState);
    const [showemailerror, setShowemailerror] = useState(false);

    const [editable2, setEditable2] = useState(true);

    const handleGolferChangenew = (field, value) => {
        setGolfer({ ...golfer, [field]: value });
    }

    const addnewgolfer = (e) => {
        e.preventDefault();
        setApicall(true);
        setApicallupdate(true);
        let Purchasedstatus = 'Yes';
        const data = {
            id: params.id,
            golfer: golfer,
            address: address,
            city: city,
            state: state,
            zip: zip
        }
        data.Purchasedstatus = Purchasedstatus;
        addnewgolferapi(data).then((response) => {
            if (!response.data.status) {
                setApicallupdate(false);
                setErrors(response.data.error);
                // setErrorid(response.data.data);
                setShowemailerror(true);
            } else {
                const data = response.data.data;
                handleaddClose();
                getremoteInquirydata();
                setGolfer(golferInitialState);
                setShowemailerror(false);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setApicallupdate(false);
        });
    }

    const [apiupate, setApiupdate] = useState(false);
    const handleupdatedata = () => {
        setEditable2(true);
        setIsLoading(true);
        setApiupdate(true);
        const data = {
            project_id: params.id,
            user_id: user,
            address: address,
            city: city,
            state: state,
            zip: zip,
            first_name: firstName,
            last_name: lastName,
            notes: descripation,
            dexterity: dexterity,
            height_ft: heightft,
            height_in: heightin,
            phone: phone,
            email: email
        }
        updatedata(data).then((response) => {
            if (!response.data.status) {
                setApicallupdate(false);
                setErrors(response.data.error);
                setEmail(dbemail)
                handleShow4();
                // setErrorid(response.data.data);
            } else {
                const data = response.data.data;
                handleaddClose();
                getremoteInquirydata();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setApicallupdate(false);
            setIsLoading(false);
            setApiupdate(false);
        });
    }

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);
    const [show4, setShow4] = useState(false);

    const [golferemail, setGolferEmail] = useState('');


    const handleCloseConfirmation2 = () => setShowConfirmation2(false);
    const handleShowConfirmation2 = () => setShowConfirmation2(true);
    const [showConfirmation2, setShowConfirmation2] = useState(false);

    const handleCloseConfirmation3 = () => setShowConfirmation3(false);
    const handleShowConfirmation3 = () => setShowConfirmation3(true);
    const [showConfirmation3, setShowConfirmation3] = useState(false);

    const [emailloader, setEmailLoader] = useState(false);

    const sendvarificationfunc = () => {
        setEmailLoader(true);
        const data = {
            email: golferemail,
        }

        sendvarification(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setEmailLoader(false);
                handleCloseConfirmation2();
                // window.location.href = '/remote_inquirie';
            }
        }).catch((err) => {
            console.log(err);
        });


    }

    const [filledFields, setFilledFields] = useState({});

    const handleSubmit = (golferId, index) => {
        setApiupdate(true);
        const golfer = golfers.find(golfer => golfer.id === golferId);
        const filledFields = Object.keys(golfer).reduce((acc, key) => {
            if (golfer[key]) {
                acc[key] = golfer[key];
            }
            return acc;
        }, {});
        setFilledFields(filledFields);

        //also add user_id to filledFields
        filledFields.project_id = params.id;
        filledFields.userindex = index;
        filledFields.purchasedstatus = "Yes";

        updatenewgolfer(filledFields).then((response) => {
            if (!response.data.status) {
                setApicallupdate(false);
                setErrors(response.data.error);
                setCheckemail(true);
                // setErrorid(response.data.data); 
            } else {
                const data = response.data.data;
                handleaddClose();
                getremoteInquirydata();
                setGolfer(golferInitialState);
                setSelectedGolfer(null);
                setCheckemail(false);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setApicallupdate(false);
            setApiupdate(false);
        });
    };

    const resetfittingfunc = () => {
        setEmailLoader(true);
        const data = {
            project_id: params.id,
            user_id: user_id,
            golfers: golfers
        }

        resetremotefitting(data).then((response) => {
            if (!response.data.status) {
                setApicallupdate(false);
                setErrors(response.data.error);
            } else {
                const data = response.data.data;
                handleCloseConfirmation3();
                handleShowreset();
                // window.location.href = "/remote_kits"
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setApicallupdate(false);
            setEmailLoader(false);
        });

    }

    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>

                        <Modal
                            show={show4} // Show the modal when `show` is true
                            onHide={handleClose4}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <h3 className="text-center">Email already exists</h3>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={show} // Show the modal when `show` is true
                            onHide={handleClose}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <h3 className="text-center">Stage update successfully</h3>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={show1}
                            onHide={handleClose1}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <h3 className="text-center">Golfer remove successfully</h3>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={show2}
                            onHide={handleClose2}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <h3 className="text-center">Data updated successfully</h3>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showreset}
                            onHide={handleClosereset}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <h3 className="text-center">Remote fitting reset successfully</h3>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showConfirmation}
                            onHide={handleCloseConfirmation}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to remove this golfer?</h4>
                                    <div className="confirmation-buttons mt-4">
                                        <Button variant="danger" onClick={removeGolfer}>
                                            Yes
                                        </Button>
                                        {' '}
                                        <Button variant="secondary" onClick={handleCloseConfirmation}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <Modal size="lg" show={showaddModal} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">Add Golfer</h3>
                                        <button type="button" className="btn-close" onClick={handleaddClose} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <Form onSubmit={addnewgolfer}>
                                        <div className="row gx-2">
                                            <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                <input type="text" name="f-name" value={golfer.firstname}
                                                    onChange={(e) => handleGolferChangenew('firstname', e.target.value)}
                                                    className="form-control dashboard-input-box-3" placeholder="First name" required />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter a first name.
                                                </Form.Control.Feedback>
                                            </div>
                                            <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                <input type="text" name="l-name" value={golfer.lastname}
                                                    onChange={(e) => handleGolferChangenew('lastname', e.target.value)}
                                                    className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter a last name.
                                                </Form.Control.Feedback>
                                            </div>
                                            <div className="col-md-12 form-group" controlid="validationCustom03">
                                                <input type="number" name="phone_number" value={golfer.phone}

                                                    onChange={(e) => handleGolferChangenew('phone', e.target.value)}
                                                    pattern="[0-9]{8,}" title="Please enter an 8-digit phone number."
                                                    className={`form-control dashboard-input-box-3 ${jsonparserror && jsonparserror.phone_number === golfer.phone_number ? 'is-invalid' : ''}`}
                                                    placeholder="Phone" required />
                                                {errors && errors.map((error, index) => (
                                                    error.field === `phone_number` ? (
                                                        <div className="invalid-feedback" key={index}>{error.detail}</div>
                                                    ) : null
                                                ))}
                                            </div>
                                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                                <input type="email"

                                                    className={`form-control dashboard-input-box-3 ${jsonparserror && jsonparserror.email === golfer.email ? 'is-invalid' : ''}`}
                                                    value={golfer.email}
                                                    onChange={(e) => handleGolferChangenew('email', e.target.value)}
                                                    name="email" placeholder="Email" required />
                                                {
                                                    showemailerror && showemailerror ? (
                                                        <div className="error" style={{ color: "red" }}>Email already exists</div>
                                                    ) : null
                                                }
                                            </div>
                                            <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                <select className="form-select form-control dashboard-input-box-3 select-custom-boxx" value={golfer.height_ft} onChange={(e) => handleGolferChangenew('height_ft', e.target.value)} aria-label="Default select example">
                                                    <option value={0}>ft.</option>
                                                    <option value="4">4 ft.</option>
                                                    <option value="5">5 ft.</option>
                                                    <option value="6">6 ft.</option>
                                                    <option value="7">7 ft.</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select ft.
                                                </Form.Control.Feedback>
                                            </div>
                                            <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                <select className="form-select form-control dashboard-input-box-3 select-custom-boxx" value={golfer.height_in} onChange={(e) => handleGolferChangenew('height_in', e.target.value)} aria-label="Default select example">
                                                    <option value={0}>in.</option>
                                                    <option value="1">0 in.</option>
                                                    <option value="2">1 in.</option>
                                                    <option value="3">2 in.</option>
                                                    <option value="4">3 in.</option>
                                                    <option value="5">4 in.</option>
                                                    <option value="6">5 in.</option>
                                                    <option value="7">6 in.</option>
                                                    <option value="8">7 in.</option>
                                                    <option value="9">8 in.</option>
                                                    <option value="10">9 in.</option>
                                                    <option value="11">10 in.</option>
                                                    <option value="12">11 in.</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select in.
                                                </Form.Control.Feedback>
                                            </div>
                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                <select className="form-select form-control dashboard-input-box-3 select-custom-boxx" value={golfer.dexterity} onChange={(e) => handleGolferChangenew('dexterity', e.target.value)} aria-label="Default select example">
                                                    <option value={0}>Dexterity</option>
                                                    <option value="1">Right Handed</option>
                                                    <option value="2">Left Handed</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Dexterity.
                                                </Form.Control.Feedback>
                                            </div>
                                            {/* <div className='row'> */}
                                            <div className='full-width-btn'>
                                                <>
                                                    <button className="btn btn-primary btn-create" type="submit">
                                                        {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Add Golfer</span>)}
                                                    </button>
                                                </>
                                            </div>
                                            {/* </div> */}
                                        </div>
                                    </Form>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <Modal
                            show={showConfirmation2}
                            onHide={handleCloseConfirmation2}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to resend email?</h4>
                                    <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                                        <Button variant="success" onClick={sendvarificationfunc} style={{ maxWidth: "3.5rem" }}>
                                            {
                                                emailloader ? <Spinner animation="border" className="border-black" /> : <span>Yes</span>
                                            }
                                        </Button>
                                        {' '}
                                        <Button variant="danger" onClick={() => {
                                            handleCloseConfirmation2();
                                        }} style={{ maxWidth: "3.5rem" }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>


                        <Modal
                            show={showConfirmation3}
                            onHide={handleCloseConfirmation3}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to reset remote fitting?</h4>
                                    <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                                        <Button variant="success" onClick={resetfittingfunc} style={{ maxWidth: "3.5rem" }}>
                                            {
                                                emailloader ? <Spinner animation="border" className="border-black" /> : <span>Yes</span>
                                            }
                                        </Button>
                                        {' '}
                                        <Button variant="danger" onClick={() => {
                                            handleCloseConfirmation3();
                                        }} style={{ maxWidth: "3.5rem" }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <div className="main-page-body-content-header">
                            <Header />
                        </div>
                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-header-new">
                                                    <button type="button" className="btn-header-transparent">
                                                        <div className="border_box_view">
                                                            <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><g clip-rule="evenodd" fill-rule="evenodd"><path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" /><path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" /></g></g></svg>
                                                                </div>
                                                                <div className="box_text_content">
                                                                    <div className="big_text">Remote Kit</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>

                                                    <div className="header-left">
                                                        <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <IoCloseSharp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col">
                                                            <div className='design_hide_mobile'>
                                                                <Form className="black_bg_box">
                                                                    <div class="add-golfer-header">

                                                                        <div class="add-golfer-header-text "></div>

                                                                        {editable2 === false ? (
                                                                            <button
                                                                                type="button"
                                                                                className="btn-close me-3"
                                                                                aria-label="Submit"
                                                                                onClick={handleupdatedata}
                                                                            >
                                                                                {apiupate ? <Spinner animation="border" className="border-black" /> : <TfiReload />}
                                                                            </button>
                                                                        ) : (
                                                                            <div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close me-3"
                                                                                    aria-label="Close"
                                                                                    onClick={() => setEditable2(false)}
                                                                                >
                                                                                    <MdOutlineModeEdit />
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close me-3"
                                                                                    aria-label="Close"
                                                                                    onClick={() => {
                                                                                        handleShowConfirmation2();
                                                                                        setGolferEmail(user);
                                                                                    }}
                                                                                >
                                                                                    <MdMarkEmailRead />
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close me-3"
                                                                                    aria-label="Close"
                                                                                    onClick={() => {
                                                                                        handleShowConfirmation3();
                                                                                    }}
                                                                                >
                                                                                    <>
                                                                                        <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" >
                                                                                            <g>
                                                                                                <g>
                                                                                                    <path d="M360.605,252.558c-1.201-5.068-4.922-9.141-9.858-10.781l-73.594-24.536l52.266-104.531    c3.281-6.577,1.318-14.575-4.644-18.882c-5.991-4.292-14.194-3.647-19.38,1.567l-150,150c-3.677,3.677-5.186,8.994-3.999,14.048    c1.201,5.068,4.922,9.141,9.858,10.781l73.594,24.536l-52.266,104.531c-3.281,6.577-1.318,14.575,4.644,18.882    c5.971,4.279,14.158,3.653,19.38-1.567l150-150C360.283,262.929,361.792,257.612,360.605,252.558z" />
                                                                                                </g>
                                                                                            </g>
                                                                                            <g>
                                                                                                <g>
                                                                                                    <path d="M256,0C179.87,0,107.961,35.406,60,92.529V76c0-8.291-6.709-15-15-15s-15,6.709-15,15v63.721c0,14.315,18.49,16.364,15,15    c0.308,0,0.615-0.015,0.923-0.029l60-3.721c8.276-0.513,14.561-7.632,14.048-15.894c-0.513-8.262-7.734-14.487-15.894-14.048    l-30.394,1.89C115.783,65.651,183.9,30,256,30c124.072,0,226,101.928,226,226c0,8.291,6.709,15,15,15c8.291,0,15-6.709,15-15    C512,115.39,396.61,0,256,0z" />
                                                                                                </g>
                                                                                            </g>
                                                                                            <g>
                                                                                                <g>
                                                                                                    <path d="M466.077,357.308l-60,3.721c-8.276,0.513-14.561,7.632-14.048,15.894s7.896,14.561,15.894,14.048l30.394-1.89    C396.217,446.349,328.1,482,256,482C131.928,482,30,380.072,30,256c0-8.291-6.709-15-15-15s-15,6.709-15,15    c0,140.61,115.39,256,256,256c76.13,0,148.039-35.406,196-92.529V436c0,8.291,6.709,15,15,15c8.291,0,15-6.709,15-15v-63.721    C482,364.039,474.099,356.856,466.077,357.308z" />
                                                                                                </g>
                                                                                            </g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                                                                                            <g></g><g></g><g></g>
                                                                                        </svg></>
                                                                                </button>
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                    <div className="row gx-2 mb-5">
                                                                        <div className="form-group custom-form-group gap-3" controlid="validationCustom01">
                                                                            <input type="text" name="f-name" disabled={editable2} className="form-control dashboard-input-box-3" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" />
                                                                            <input type="text" name="l-name" disabled={editable2} onChange={(e) => setLastName(e.target.value)} className="form-control dashboard-input-box-3" value={lastName} placeholder="Last name" />
                                                                        </div>
                                                                        <div className="form-group" controlid="validationCustom03">
                                                                            <input type="tel" name="name" disabled={editable2} pattern="[0-9]{8,}" onChange={(e) => setPhone(e.target.value)} title="Please enter a 8-digit phone number." value={phone} className="form-control dashboard-input-box-3" placeholder="Phone" />
                                                                        </div>
                                                                        <div className="form-group" controlid="validationCustom04">
                                                                            <input type="email" disabled={editable2} className="form-control dashboard-input-box-3" name="email" value={email} placeholder="Email" onChange={(e) => { setEmail(e.target.value) }} />
                                                                        </div>

                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={editable2} value={heightft} onChange={(e) => setHeightft(e.target.value)} aria-label="Default select example">
                                                                                <option value={0}>ft.</option>
                                                                                <option value="4">4 ft.</option>
                                                                                <option value="5">5 ft.</option>
                                                                                <option value="6">6 ft.</option>
                                                                                <option value="7">7 ft.</option>
                                                                            </select>
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please select a ft.
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={editable2} value={heightin} onChange={(e) => setHeightin(e.target.value)} aria-label="Default select example">
                                                                                <option value={0}>in.</option>
                                                                                <option value="1">0 in.</option>
                                                                                <option value="2">1 in.</option>
                                                                                <option value="3">2 in.</option>
                                                                                <option value="4">3 in.</option>
                                                                                <option value="5">4 in.</option>
                                                                                <option value="6">5 in.</option>
                                                                                <option value="7">6 in.</option>
                                                                                <option value="8">7 in.</option>
                                                                                <option value="9">8 in.</option>
                                                                                <option value="10">9 in.</option>
                                                                                <option value="11">10 in.</option>
                                                                                <option value="12">11 in.</option>
                                                                            </select>
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please select a in.
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={editable2} value={dexterity} onChange={(e) => setDexterity(e.target.value)} aria-label="Default select example">
                                                                                <option value={0}>Dexterity</option>
                                                                                <option value="1">Right Handed</option>
                                                                                <option value="2">Left Handed</option>
                                                                            </select>
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please select a Dexterity
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-lg-12">
                                                                            <div className="form-group" controlid="validationCustom06">
                                                                                <input type="text" disabled={editable2} className="form-control dashboard-input-box-3" name="address" value={address}
                                                                                    onChange={(e) => setAddress(e.target.value)} placeholder="Address" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-6 form-group" controlid="validationCustom01">
                                                                            <input type="text" name="f-name" disabled={editable2} className="form-control dashboard-input-box-3" value={city} placeholder="City"
                                                                                onChange={(e) => setCity(e.target.value)}
                                                                                required />
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please enter City
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-4 col-md-3 form-group" controlid="validationCustom02">
                                                                            <input type="text" name="l-name" disabled={editable2} className="form-control dashboard-input-box-3" value={state} placeholder="State"
                                                                                onChange={(e) => setState(e.target.value)} required />
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please enter State
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-4 col-md-3 form-group" controlid="validationCustom02">
                                                                            <input type="text" name="l-name" disabled={editable2} className="form-control dashboard-input-box-3"
                                                                                onChange={(e) => setZip(e.target.value)}
                                                                                value={zip} placeholder="Zip Code" required />
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please enter Zip Code
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className='' controlid="validationCustom05">
                                                                            <textarea disabled={editable2} className="form-control dashboard-input-box-3 step-textarea-box" onChange={(e) => setDescripation(e.target.value)} name="message" value={descripation} placeholder="Let us now what you need!" rows="8"></textarea>
                                                                        </div>
                                                                    </div>
                                                                    {golfers.map((golfer, index) => (
                                                                        <div key={golfer.id} className="add-golfer-section mb-4">
                                                                            <div className="add-golfer-header">
                                                                                <div className="add-golfer-header-text " style={{ color: "#f3fcff" }}>
                                                                                    <h3>{index + 1}. {golfer.firstName} {golfer.lastName}</h3>
                                                                                </div>
                                                                                <div className="remove-golfer-section">
                                                                                    {selectedGolfer === golfer.id ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn-close me-3"
                                                                                            aria-label="Submit"
                                                                                            onClick={() => handleSubmit(golfer.id, index)}
                                                                                        >
                                                                                            {
                                                                                                apiupate ? <Spinner animation="border" className="border-black" /> : <TfiReload />
                                                                                            }

                                                                                        </button>
                                                                                    ) : (
                                                                                        <>
                                                                                            <button type="button" className="btn-close me-3" aria-label="Close" onClick={() => { setSelectedGolfer(golfer.id) }}>
                                                                                                <MdOutlineModeEdit />
                                                                                            </button>

                                                                                            <button type="button" className="btn-close me-3" aria-label="Close" onClick={() => { handleShowConfirmation(); setSelectedGolfer(golfer.id) }}>
                                                                                                <IoClose />
                                                                                            </button>

                                                                                            <button type="button" className="btn-close me-3" aria-label="Close" onClick={(e) => { handleShowConfirmation2(); setGolferEmail(golfer.id) }}>
                                                                                                <MdMarkEmailRead />
                                                                                            </button>
                                                                                        </>

                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="add-golfer-body">
                                                                                <div className="row gx-2">
                                                                                    <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                                                        <input type="text" name="f-name" value={golfer.firstName} disabled={selectedGolfer !== golfer.id}
                                                                                            onChange={(e) => handleGolferChange(index, 'firstName', e.target.value)}
                                                                                            className="form-control dashboard-input-box-3" placeholder="First name" required />
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please enter a first name.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                                                        <input type="text" name="l-name" value={golfer.lastName}
                                                                                            disabled={selectedGolfer !== golfer.id}
                                                                                            onChange={(e) => handleGolferChange(index, 'lastName', e.target.value)} className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please enter a first name.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                                        <input type="tel" name="phone_number" value={golfer.phone_number}
                                                                                            disabled={selectedGolfer !== golfer.id}
                                                                                            onChange={(e) => handleGolferChange(index, 'phone_number', e.target.value)} pattern="[0-9]{8,}" title="Please enter a 8-digit phone number."
                                                                                            // className="form-control dashboard-input-box-3" 
                                                                                            className={`form-control dashboard-input-box-3 ${jsonparserror && jsonparserror.phone_number === golfer.phone_number ? 'is-invalid' : ''}`}
                                                                                            placeholder="Phone" required />
                                                                                        {errors && errors.map((error, index) => (
                                                                                            error.field === `phone_number` ? (
                                                                                                <div className="invalid-feedback" key={index}>{error.detail}</div>
                                                                                            ) : null
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                        <input type="email"
                                                                                            disabled={selectedGolfer !== golfer.id}
                                                                                            // className="form-control dashboard-input-box-3" 
                                                                                            className={`form-control dashboard-input-box-3 ${jsonparserror && jsonparserror.email === golfer.email ? 'is-invalid' : ''}`}
                                                                                            value={golfer.email}
                                                                                            onChange={(e) => handleGolferChange(index, 'email', e.target.value)}
                                                                                            name="email" placeholder="Email" required />
                                                                                        {errors && errors.map((error, index) => (
                                                                                            error.field === `email` ? (
                                                                                                <div className="invalid-feedback" key={index}>{error.detail}</div>
                                                                                            ) : null
                                                                                        ))}
                                                                                        {selectedGolfer === golfer.id ? (checkemail === true ? <div className="" style={{ color: "red" }}>Email already exists</div> : null) : null}
                                                                                    </div>
                                                                                    <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={selectedGolfer !== golfer.id} value={golfer.heightft} onChange={(e) => handleGolferChange(index, 'heightft', e.target.value)} aria-label="Default select example">
                                                                                            <option value={0}>ft.</option>
                                                                                            <option value="4">4 ft.</option>
                                                                                            <option value="5">5 ft.</option>
                                                                                            <option value="6">6 ft.</option>
                                                                                            <option value="7">7 ft.</option>
                                                                                        </select>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please select a ft.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={selectedGolfer !== golfer.id} value={golfer.heightin} onChange={(e) => handleGolferChange(index, 'heightin', e.target.value)} aria-label="Default select example">
                                                                                            <option value={0}>in.</option>
                                                                                            <option value="1">0 in.</option>
                                                                                            <option value="2">1 in.</option>
                                                                                            <option value="3">2 in.</option>
                                                                                            <option value="4">3 in.</option>
                                                                                            <option value="5">4 in.</option>
                                                                                            <option value="6">5 in.</option>
                                                                                            <option value="7">6 in.</option>
                                                                                            <option value="8">7 in.</option>
                                                                                            <option value="9">8 in.</option>
                                                                                            <option value="10">9 in.</option>
                                                                                            <option value="11">10 in.</option>
                                                                                            <option value="12">11 in.</option>
                                                                                        </select>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please select a in.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={selectedGolfer !== golfer.id} value={golfer.dexterity} onChange={(e) => handleGolferChange(index, 'dexterity', e.target.value)} aria-label="Default select example">
                                                                                            <option value={0}>Dexterity</option>
                                                                                            <option value="1">Right Handed</option>
                                                                                            <option value="2">Left Handed</option>
                                                                                        </select>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please select a Dexterity
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <div className="col-md-12 text-center" >
                                                                        <div className='full-width-btn'>
                                                                            {/* {
                                                                                status !== 'Purchased' ? (
                                                                                    <button className="btn btn_default bg-white text-dark btn_disabled" onClick={addGolfer} type="button">
                                                                                        <span>+ Add Golfer</span>
                                                                                    </button>
                                                                                ) : (
                                                                                    <button className="btn btn_default bg-white text-dark btn_disabled" onClick={addGolfer} type="button" disabled>
                                                                                        <span>+ Add Golfer</span>
                                                                                    </button>
                                                                                )
                                                                            } */}
                                                                            <button className="btn btn_default bg-white text-dark btn_disabled" onClick={handleaddShow} type="button">
                                                                                <span>+ Add Golfer</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {/* <h3 className="text mt-5 mb-3">Authorize this remote fitting</h3>
                                                        <div className="description mb-5">
                                                            Once you submit this all golfers will receive fittings to their dashboards and no other guests can be invited
                                                        </div>
                                                        <div className="col-md-12 text-center">
                                                            <div className='full-width-btn'>
                                                                {
                                                                    status === 'rejected' ? (
                                                                        <button className="btn btn_default bg-white text-dark btn_disabled" onClick={handleAuthorize} >
                                                                            {apicall ? <Spinner animation="border" className="border-black" /> : <span>Authorize Fitting</span>}
                                                                        </button>
                                                                    ) : (
                                                                        <button className="btn btn_default bg-white text-dark btn_disabled" disabled>
                                                                            <span>Authorized</span>
                                                                        </button>
                                                                    )
                                                                }

                                                            </div>
                                                        </div> */}
                                                                </Form>
                                                            </div>
                                                            <div className='design_show_mobile'>
                                                                <Form className="black_bg_box">

                                                                    <div className="add-golfer-header">
                                                                        <div className="add-golfer-header-text " style={{ color: "#f3fcff" }}>
                                                                            {/* <h3>Primary golfer</h3> */}
                                                                        </div>
                                                                        <div className="remove-golfer-section">
                                                                            {editable2 === false ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close me-3"
                                                                                    aria-label="Submit"
                                                                                    onClick={handleupdatedata}
                                                                                >
                                                                                    {apiupate ? <Spinner animation="border" className="border-black" /> : <TfiReload />}
                                                                                </button>
                                                                            ) : (
                                                                                <div>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn-close me-3"
                                                                                        aria-label="Close"
                                                                                        onClick={() => setEditable2(false)}
                                                                                    >
                                                                                        <MdOutlineModeEdit />
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn-close me-3"
                                                                                        aria-label="Close"
                                                                                        onClick={() => {
                                                                                            handleShowConfirmation2();
                                                                                            setGolferEmail(user);
                                                                                        }}
                                                                                    >
                                                                                        <MdMarkEmailRead />
                                                                                    </button>
                                                                                </div>
                                                                            )}

                                                                        </div>

                                                                    </div>


                                                                    <div className="row gx-2 mb-5">
                                                                        <div className="form-group custom-form-group gap-3" controlid="validationCustom01">
                                                                            <input type="text" name="f-name" disabled={editable2} className="form-control dashboard-input-box-3" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" />
                                                                            <input type="text" name="l-name" disabled={editable2} onChange={(e) => setLastName(e.target.value)} className="form-control dashboard-input-box-3" value={lastName} placeholder="Last name" />
                                                                        </div>
                                                                        <div className="form-group" controlid="validationCustom03">
                                                                            <input type="tel" name="name" disabled={editable2} pattern="[0-9]{8,}" onChange={(e) => setPhone(e.target.value)} title="Please enter a 8-digit phone number." value={phone} className="form-control dashboard-input-box-3" placeholder="Phone" />
                                                                        </div>
                                                                        <div className="form-group" controlid="validationCustom04">
                                                                            <input type="email" disabled={editable2} className="form-control dashboard-input-box-3" name="email" value={email} placeholder="Email" onChange={(e) => { setEmail(e.target.value) }} />
                                                                        </div>

                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={editable2} value={heightft} onChange={(e) => setHeightft(e.target.value)} aria-label="Default select example">
                                                                                <option value={0}>ft.</option>
                                                                                <option value="4">4 ft.</option>
                                                                                <option value="5">5 ft.</option>
                                                                                <option value="6">6 ft.</option>
                                                                                <option value="7">7 ft.</option>
                                                                            </select>
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please select a ft.
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={editable2} value={heightin} onChange={(e) => setHeightin(e.target.value)} aria-label="Default select example">
                                                                                <option value={0}>in.</option>
                                                                                <option value="1">0 in.</option>
                                                                                <option value="2">1 in.</option>
                                                                                <option value="3">2 in.</option>
                                                                                <option value="4">3 in.</option>
                                                                                <option value="5">4 in.</option>
                                                                                <option value="6">5 in.</option>
                                                                                <option value="7">6 in.</option>
                                                                                <option value="8">7 in.</option>
                                                                                <option value="9">8 in.</option>
                                                                                <option value="10">9 in.</option>
                                                                                <option value="11">10 in.</option>
                                                                                <option value="12">11 in.</option>
                                                                            </select>
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please select a in.
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={editable2} value={dexterity} onChange={(e) => setDexterity(e.target.value)} aria-label="Default select example">
                                                                                <option value={0}>Dexterity</option>
                                                                                <option value="1">Right Handed</option>
                                                                                <option value="2">Left Handed</option>
                                                                            </select>
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please select a Dexterity
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-lg-12">
                                                                            <div className="form-group" controlid="validationCustom06">
                                                                                <input type="text" disabled={editable2} className="form-control dashboard-input-box-3" name="address" value={address}
                                                                                    onChange={(e) => setAddress(e.target.value)} placeholder="Address" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 col-md-6 form-group" controlid="validationCustom01">
                                                                            <input type="text" name="f-name" disabled={editable2} className="form-control dashboard-input-box-3" value={city} placeholder="City"
                                                                                onChange={(e) => setCity(e.target.value)}
                                                                                required />
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please enter City
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-4 col-md-3 form-group" controlid="validationCustom02">
                                                                            <input type="text" name="l-name" disabled={editable2} className="form-control dashboard-input-box-3" value={state} placeholder="State"
                                                                                onChange={(e) => setState(e.target.value)} required />
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please enter State
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className="col-4 col-md-3 form-group" controlid="validationCustom02">
                                                                            <input type="text" name="l-name" disabled={editable2} className="form-control dashboard-input-box-3"
                                                                                onChange={(e) => setZip(e.target.value)}
                                                                                value={zip} placeholder="Zip Code" required />
                                                                            <Form.Control.Feedback type="invalid">
                                                                                Please enter Zip Code
                                                                            </Form.Control.Feedback>
                                                                        </div>
                                                                        <div className='' controlid="validationCustom05">
                                                                            <textarea disabled={editable2} className="form-control dashboard-input-box-3 step-textarea-box" onChange={(e) => setDescripation(e.target.value)} name="message" value={descripation} placeholder="Let us now what you need!" rows="8"></textarea>
                                                                        </div>
                                                                    </div>
                                                                    {golfers.map((golfer, index) => (
                                                                        <div key={golfer.id} className="add-golfer-section mb-4">
                                                                            <div className="add-golfer-header">
                                                                                <div className="add-golfer-header-text " style={{ color: "#f3fcff" }}>
                                                                                    <h3>{index + 1}. {golfer.firstName} {golfer.lastName}</h3>
                                                                                </div>
                                                                                <div className="remove-golfer-section">
                                                                                    {selectedGolfer === golfer.id ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn-close me-3"
                                                                                            aria-label="Submit"
                                                                                            onClick={() => handleSubmit(golfer.id, index)}
                                                                                        >
                                                                                            {
                                                                                                apiupate ? <Spinner animation="border" className="border-black" /> : <TfiReload />
                                                                                            }

                                                                                        </button>
                                                                                    ) : (
                                                                                        <>
                                                                                            <button type="button" className="btn-close me-3" aria-label="Close" onClick={() => { setSelectedGolfer(golfer.id) }}>
                                                                                                <MdOutlineModeEdit />
                                                                                            </button>

                                                                                            <button type="button" className="btn-close me-3" aria-label="Close" onClick={() => { handleShowConfirmation(); setSelectedGolfer(golfer.id) }}>
                                                                                                <IoClose />
                                                                                            </button>

                                                                                            <button type="button" className="btn-close me-3" aria-label="Close" onClick={(e) => { handleShowConfirmation2(); setGolferEmail(golfer.id) }}>
                                                                                                <MdMarkEmailRead />
                                                                                            </button>
                                                                                        </>

                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="add-golfer-body">
                                                                                <div className="row gx-2">
                                                                                    <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                                                        <input type="text" name="f-name" value={golfer.firstName} disabled={selectedGolfer !== golfer.id}
                                                                                            onChange={(e) => handleGolferChange(index, 'firstName', e.target.value)}
                                                                                            className="form-control dashboard-input-box-3" placeholder="First name" required />
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please enter a first name.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                                                        <input type="text" name="l-name" value={golfer.lastName}
                                                                                            disabled={selectedGolfer !== golfer.id}
                                                                                            onChange={(e) => handleGolferChange(index, 'lastName', e.target.value)} className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please enter a first name.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                                        <input type="tel" name="phone_number" value={golfer.phone_number}
                                                                                            disabled={selectedGolfer !== golfer.id}
                                                                                            onChange={(e) => handleGolferChange(index, 'phone_number', e.target.value)} pattern="[0-9]{8,}" title="Please enter a 8-digit phone number."
                                                                                            // className="form-control dashboard-input-box-3" 
                                                                                            className={`form-control dashboard-input-box-3 ${jsonparserror && jsonparserror.phone_number === golfer.phone_number ? 'is-invalid' : ''}`}
                                                                                            placeholder="Phone" required />
                                                                                        {errors && errors.map((error, index) => (
                                                                                            error.field === `phone_number` ? (
                                                                                                <div className="invalid-feedback" key={index}>{error.detail}</div>
                                                                                            ) : null
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                        <input type="email"
                                                                                            disabled={selectedGolfer !== golfer.id}
                                                                                            // className="form-control dashboard-input-box-3" 
                                                                                            className={`form-control dashboard-input-box-3 ${jsonparserror && jsonparserror.email === golfer.email ? 'is-invalid' : ''}`}
                                                                                            value={golfer.email}
                                                                                            onChange={(e) => handleGolferChange(index, 'email', e.target.value)}
                                                                                            name="email" placeholder="Email" required />
                                                                                        {errors && errors.map((error, index) => (
                                                                                            error.field === `email` ? (
                                                                                                <div className="invalid-feedback" key={index}>{error.detail}</div>
                                                                                            ) : null
                                                                                        ))}
                                                                                        {selectedGolfer === golfer.id ? (checkemail === true ? <div className="" style={{ color: "red" }}>Email already exists</div> : null) : null}
                                                                                    </div>
                                                                                    <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={selectedGolfer !== golfer.id} value={golfer.heightft} onChange={(e) => handleGolferChange(index, 'heightft', e.target.value)} aria-label="Default select example">
                                                                                            <option value={0}>ft.</option>
                                                                                            <option value="4">4 ft.</option>
                                                                                            <option value="5">5 ft.</option>
                                                                                            <option value="6">6 ft.</option>
                                                                                            <option value="7">7 ft.</option>
                                                                                        </select>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please select a ft.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={selectedGolfer !== golfer.id} value={golfer.heightin} onChange={(e) => handleGolferChange(index, 'heightin', e.target.value)} aria-label="Default select example">
                                                                                            <option value={0}>in.</option>
                                                                                            <option value="1">0 in.</option>
                                                                                            <option value="2">1 in.</option>
                                                                                            <option value="3">2 in.</option>
                                                                                            <option value="4">3 in.</option>
                                                                                            <option value="5">4 in.</option>
                                                                                            <option value="6">5 in.</option>
                                                                                            <option value="7">6 in.</option>
                                                                                            <option value="8">7 in.</option>
                                                                                            <option value="9">8 in.</option>
                                                                                            <option value="10">9 in.</option>
                                                                                            <option value="11">10 in.</option>
                                                                                            <option value="12">11 in.</option>
                                                                                        </select>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please select a in.
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={selectedGolfer !== golfer.id} value={golfer.dexterity} onChange={(e) => handleGolferChange(index, 'dexterity', e.target.value)} aria-label="Default select example">
                                                                                            <option value={0}>Dexterity</option>
                                                                                            <option value="1">Right Handed</option>
                                                                                            <option value="2">Left Handed</option>
                                                                                        </select>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            Please select a Dexterity
                                                                                        </Form.Control.Feedback>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    {/* <div className="col-md-12 text-center" >
                                                                        <div className='full-width-btn'>
                                                                            <button className="btn btn_default bg-white text-dark btn_disabled" onClick={handleaddShow} type="button">
                                                                                <span>+ Add Golfer</span>
                                                                            </button>
                                                                        </div>
                                                                    </div> */}
                                                                </Form>
                                                            </div>
                                                        </div>
                                                        <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? "tab_fix" : ""}`}>
                                                            <div className="fix_sec_view container-fluid ps-0">
                                                                {/* <div className="select-dropdown-build">
                                                        <div className={`select-options-dropdown ${isOpen3 ? 'open' : ''}`}>
                                                            <div className='select-option-inner' onClick={status !== 'Purchased' || selectedOption3 !== "Remote Kit"  ? null : toggleDropdown3} >
                                                                <div className='selected-option-text'>{selectedOption3}</div>
                                                                <span className={`icon ${isOpen3 ? 'up' : 'down'}`}>
                                                                    <i className="bi bi-chevron-down" />
                                                                </span>
                                                            </div>
                                                            {isOpen3 && (
                                                                <div className='option-list buildsheet-option-list'>
                                                                    <div className='drop-down-list'>
                                                                        {options3.map(option => (
                                                                            <div
                                                                                key={option.text}
                                                                                className={`drop-down-item ${selectedOption3 === option.text ? 'active' : ''}`}
                                                                                onClick={() => selectOption3(option)}
                                                                            >
                                                                                <div className='drop-down-item-icon'>
                                                                                    <span className={`icon-color color-${option.color}`}></span>
                                                                                </div>
                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    <div className='form-box-section'>
                                                                        {
                                                                            selectedOption3 === "Remote Kit" ? (
                                                                                <button
                                                                                    className="btn btn-primary btn-create"
                                                                                    disabled
                                                                                >
                                                                                    <span>Assign Kit</span>
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    className="btn btn-primary btn-create"
                                                                                    onClick={assignremoteKit}
                                                                                >

                                                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Assign Kit</span>)}
                                                                                </button>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div> */}
                                                                <div className='select-dropdown-build mt-0'>
                                                                    <div className={`select-options-dropdown ${isOpen2 ? 'open' : ''}`}>
                                                                        {/* <div className='select-option-inner' onClick={status === 'Purchased' ? null : toggleDropdown2} > */}
                                                                        <div className='select-option-inner' onClick={toggleDropdown2} >
                                                                            <span className={`icon-color color-${getColorClass()}`}></span>
                                                                            <div className='selected-option-text'>{selectedOption2}</div>
                                                                            <span className={`icon ${isOpen2 ? 'up' : 'down'}`}>
                                                                                <i className="bi bi-chevron-down" />
                                                                            </span>
                                                                        </div>

                                                                        {isOpen2 && (
                                                                            <div className='option-list buildsheet-option-list'>
                                                                                <div className='drop-down-list'>
                                                                                    {options2.map(option => (
                                                                                        <div
                                                                                            key={option.text}
                                                                                            className={`drop-down-item ${selectedOption2 === option.text ? 'active' : ''}`}
                                                                                            onClick={() => selectOption2(option.text)}
                                                                                        >
                                                                                            <div className='drop-down-item-icon'>
                                                                                                <span className={`icon-color color-${option.color}`}> </span>
                                                                                            </div>
                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className='form-box-section'>
                                                                                    {
                                                                                        selectedOption2 === "Assigned" ? (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                disabled
                                                                                            >
                                                                                                <span>Update Status</span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                onClick={updateRemotekitstatus}
                                                                                            >

                                                                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                            </button>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className='design_hide_mobile'>
                                                                    <div className="tab-box-section notes-tab">
                                                                        <div className="form-group">
                                                                            <textarea value={notes} onChange={(e) => setnotes(e.target.value)} className="dashboard-text-area" id="exampleFormControlTextarea1" rows="10" placeholder="Leave your note here..." ></textarea>
                                                                            {
                                                                                showerror && <div className="error-msg " style={{ color: 'red' }}>Please enter notes</div>
                                                                            }
                                                                        </div>
                                                                        <div className='text-center'>
                                                                            <button className="btn btn-create" onClick={handleaddnotes}>{apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Add Note</span>)}</button>
                                                                        </div>
                                                                    </div>
                                                                    <>
                                                                        {
                                                                            notesdata.length === 0 ? (
                                                                                <div className="tab-box-section notes-tab mt-4">
                                                                                    <div className='no-data-img'>
                                                                                        <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                                                    </div>
                                                                                    <div className="no-data-text">
                                                                                        <h3>No data Found</h3>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                                :
                                                                                notesdata.map((item, i) => {
                                                                                    return (
                                                                                        <div className="dashboard-sec new_activity">
                                                                                            <div className="tab-box-section activity-form-box">
                                                                                                <div className="form-list-inner">
                                                                                                    <div className="form-list-title activity-title">
                                                                                                        <div className="emp-name">
                                                                                                            <div className="emp-light">Employee:</div>
                                                                                                            <div className="emp-bold">{item ? item.customer : ''}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="form-card-body-status">
                                                                                                        {item.notes}
                                                                                                    </div>
                                                                                                    <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                        }
                                                                    </>
                                                                </div>
                                                                <div className='design_show_mobile'>
                                                                    <div className="tab-box-section notes-tab">
                                                                        <div className="form-group">
                                                                            <textarea value={notes} onChange={(e) => setnotes(e.target.value)} className="dashboard-text-area" id="exampleFormControlTextarea1" rows="10" placeholder="Leave your note here..." ></textarea>
                                                                            {
                                                                                showerror && <div className="error-msg " style={{ color: 'red' }}>Please enter notes</div>
                                                                            }
                                                                        </div>
                                                                        <div className='text-center'>
                                                                            <button className="btn btn-create" onClick={handleaddnotes}>{apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Add Note</span>)}</button>
                                                                        </div>
                                                                    </div>
                                                                    <>
                                                                        {
                                                                            notesdata.length === 0 ? (
                                                                                <div className="tab-box-section notes-tab mt-4">
                                                                                    <div className='no-data-img'>
                                                                                        <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                                                    </div>
                                                                                    <div className="no-data-text">
                                                                                        <h3>No data Found</h3>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                                :
                                                                                notesdata.map((item, i) => {
                                                                                    return (
                                                                                        <div className="dashboard-sec new_activity">
                                                                                            <div className="tab-box-section activity-form-box">
                                                                                                <div className="form-list-inner">
                                                                                                    <div className="form-list-title activity-title">
                                                                                                        <div className="emp-name">
                                                                                                            <div className="emp-light">Employee:</div>
                                                                                                            <div className="emp-bold">{item ? item.customer : ''}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="form-card-body-status">
                                                                                                        {item.notes}
                                                                                                    </div>
                                                                                                    <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                        }
                                                                    </>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
}

function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
}

export default RemotekitView;

